// This is the wrapper for the form widget section
import { useFormEngineContext } from './formContext'
import { formHelp } from './formHelpers'
import { fieldSetValidation } from './fieldSetValidation'
import { FormActionKind } from './formReducer'
import { widgetHelpers } from './widgetHelpers'
import { GroupWidget } from './GroupWidget'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useFieldContext } from './fieldInstanceContext'
import { indexOf } from 'underscore'
import { useSelector } from 'react-redux'
import { getCurrentUserData, RootState } from '../../Redux/store'
import DatePicker from '../../Components/DatePicker/DatePicker'

export const UpdateFormSection = React.memo(
    (props: {
        addAuditComment: any
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void
        setShowPopupMessage: (show: boolean) => void
        formDisabled: boolean
    }) => {
        const { addAuditComment, setPopUpInfo, setShowPopupMessage, formDisabled } = props
        const { fieldState } = useFieldContext()

        return (
            <div id="updateFormSection">
                {/* TODO add disabled toggle */}
                <div id="updateSectionScroll" className="scroll-container scroll-fade bg-white">
                    <div className={'card main border-none ' + (formDisabled ? 'disabled' : '')}>
                        {fieldState.fieldInstances !== undefined &&
                            fieldState.fieldInstances.map((fieldSetInst: any, i: number) => {
                                // Here is where the Fieldset is Mounted. Multiple instances like Legions are indexed by the rank value

                                // fieldSetInst is the list of fields for this fieldInstance
                                // index is the index in the list of all fieldInstances for this field instances
                                return (
                                    <FieldSet
                                        formDisabled={formDisabled}
                                        key={i}
                                        setIndex={i}
                                        instance={fieldSetInst}
                                        setShowPopupMessage={setShowPopupMessage}
                                        setPopUpInfo={setPopUpInfo}
                                    />
                                )
                            })}
                    </div>
                </div>
            </div>
        )
    }
)

const FieldInfo = (props: {
    formDisabled: boolean
    field: { [s: string]: any }
    fieldSetInstance: { [s: string]: any }
    setIndex: number
    fieldIndex: number
    updateFieldIndex: any
    updateFieldValue: any
    updateValue: any
}) => {
    const {
        formDisabled,
        field,
        fieldSetInstance,
        setIndex,
        fieldIndex,
        updateFieldIndex,
        updateFieldValue,
        updateValue,
    } = props
    const { formState } = useFormEngineContext()
    const { fieldDispatch } = useFieldContext()
    // let outer = outer //TODO ?
    let id = field.id
    let title = field.name
    let domid = `field${id}_${setIndex}`
    let option
    let key
    
    // TODO: pass in setter functions for context so they can change fields on form
    switch (field.type?.toLowerCase()) {
        case 'checkbox':
            const isChecked = !formHelp.isEmptyField(field) && field.value
            // TODO this is based on the old checkbox code. We should find a simpler way to track
            // the checkbox state and pass it to the field instance
            return (
                <label>
                    <input
                        type="checkbox"
                        name={domid}
                        value={title}
                        disabled={formDisabled}
                        checked={isChecked}
                        onChange={(e) => {
                            updateFieldIndex([])
                            if (field.value) {
                                updateFieldValue(['NO'])
                                updateValue(0)
                            } else {
                                updateFieldValue(['YES'])
                                updateValue(1)
                            }
                        }}
                    />
                    <span className="checkable">{title}</span>
                </label>
            )
        case 'checkboxgroup':
            return GroupWidget({
                field: field,
                fieldSetInstance: fieldSetInstance,
                setIndex: setIndex,
                updateFieldValue: updateFieldValue,
            })
        case 'radio':
        case 'radioselect':
            return GroupWidget({
                field: field,
                fieldSetInstance: fieldSetInstance,
                setIndex: setIndex,
                updateFieldValue: updateFieldValue,
            })
        case 'select':
            return (
                <select
                    id={domid}
                    disabled={formDisabled}
                    name={domid}
                    value={field.value}
                    onChange={(e) => {
                        updateFieldIndex([e.target.value])
                    }}
                >
                    {field.domain.map((item: { value: any; key: any }, i: number) => {
                        const idx =
                            field.fieldIndex && field.fieldIndex.length > 0
                                ? field.fieldIndex[0]
                                : 0
                        const selectedState = idx === i
                        option = item.value
                        key = item.key
                        return (
                            <option value={key} key={key} selected={selectedState}>
                                {option}
                            </option>
                        )
                    })}
                </select>
            )
        case 'range':
            return (
                <input
                    id={domid}
                    placeholder={title}
                    disabled={formDisabled}
                    value={field.fieldValue[0] ?? ''}
                    type="range"
                    onChange={(e) => {
                        updateFieldIndex([e.target.value])
                    }}
                />
            )
        case 'text':
            return (
                <input
                    id={domid}
                    type="text"
                    disabled={formDisabled}
                    placeholder={title}
                    value={field.fieldValue[0] ?? ''}
                    maxLength={1000}
                    onChange={(e) => {
                        updateFieldValue([e.target.value])
                    }}
                />
            )
        case 'time':
            const dateValue = new Date(field.fieldValue[0])
            const hours = String(dateValue.getHours()).padStart(2, '0')
            const minutes = String(dateValue.getMinutes()).padStart(2, '0')
            return (
                <input
                    id={domid}
                    type="time"
                    disabled={formDisabled}
                    defaultValue={field.fieldValue[0] ?? ''}
                    placeholder={title}
                    value={field.fieldValue[0] ? `${hours}:${minutes}` : ''}
                    onChange={(e) => {
                        const m = moment(e.target.value, 'hh:mm A')
                        if (m.isValid()) {
                            updateFieldValue([m.format('MM/DD/YYYY hh:mm A')])
                        } else {
                            updateFieldValue([''])
                        }
                        if (typeof e.target.value === 'undefined') {
                            if (!isNaN(Date.parse(field.value)))
                                updateValue(
                                    new Date(field.value).toTimeString().split(' ')[0].slice(0, -3)
                                )
                        }
                    }}
                />
            )
        case 'datetime-local':
            return (
                <input
                    id={domid}
                    type="datetime-local"
                    disabled={formDisabled}
                    placeholder={title}
                    value={field.fieldValue[0] ?? ''}
                    onChange={(e) => {
                        const m = moment(e.target.value)
                        if (m.isValid()) {
                            updateFieldValue([m.format('HH:mm')])
                        } else {
                            updateFieldValue([''])
                        }
                        if (typeof e.target.value === 'undefined') {
                            if (!isNaN(Date.parse(field.value)))
                                updateValue(
                                    new Date(field.value).toTimeString().split(' ')[0].slice(0, -3)
                                )
                            if (field.type === 'datetime-local') {
                                try {
                                    const val = new Date(field.fieldValue[0])
                                    updateValue(moment(val).format('YYYY-MM-DDTkk:mm'))
                                } catch (e) {
                                    console.error(e)
                                }
                            }
                        }
                    }}
                />
            )
        case 'date':
            return (
                <input
                    id={domid}
                    type="date"
                    disabled={formDisabled}
                    placeholder={title}
                    value={field.value ?? ''}
                    onChange={(event) => {
                        const date = moment(event.target.value)
                        if (date.isValid()) {
                            updateFieldValue([date.format('MM/DD/YYYY')])
                        } else {
                            updateFieldValue([''])
                        }
                        updateValue(date.format('YYYY-MM-DD'))
                        // updateFieldIndex([event.target.value <= 0 ? -1 : event.target.value])
                    }}
                />   
            )
        case 'textarea':
            return (
                <textarea
                    id={domid}
                    disabled={formDisabled}
                    rows={6}
                    maxLength={1500}
                    placeholder={title}
                    value={field.fieldValue[0] ?? ''}
                    onChange={(e) => {
                        updateFieldValue([e.target.value])
                    }}
                />
            )
        case 'contextview':
            const OCVData = formState.ocvData ? formState.ocvData[field.name] : {}
            return (
                <div style={{ padding: '5px' }} id={field.name.toLowerCase()}>
                    {OCVData != null ? formHelp.getOCVFormattedView(OCVData, '') : ''}
                </div>
            )
        case 'button':
            return (
                <input
                    id={domid}
                    type="button"
                    disabled={formDisabled}
                    value="Button Text"
                    onClick={() => {
                        console.error('on click not implemented')
                    }}
                />
            )
        case 'note':
            // TODO handle adjusting color for night mode
            return (
                <div style={{ padding: '5px', backgroundColor: field.fieldValue[0] }}>
                    {field.name}
                </div>
            )
        case 'separator':
            let currentValue = field.fieldValue[0] !== undefined ? field.fieldValue[0] : '#66abd3'
            let validity = field.validator ? field.validator(field, fieldSetInstance) || {} : false
            return (
                <div
                    style={{
                        padding: '5px',
                        color: 'white',
                        backgroundColor: currentValue,
                    }}
                >
                    {field.name}
                    {field.type == 'contextView' ? (
                        <span className="fieldstatus px-0 text-right text-md-left">
                            {formHelp.validityFieldStatus(validity)}
                            <span
                                id={`fieldhelp-${field.id}`}
                                className="px-2 info-icon"
                                title={field.help ? field.help.replace(/<br>/g, '') : ''}
                            >
                                ⓘ
                            </span>
                            {field.help ? widgetHelpers.help({ text: field.help }) : ''}
                            <span
                                id={`fieldinfo-${field.id}`}
                                className="px-2 info-icon"
                                onClick={
                                    () => {
                                        if (!formState.isReadOnly) {
                                        }
                                        alert('need to enable onclick dialog')
                                    }
                                    // TODO show dialog here
                                    // function () {
                                    //     var bd = new BigDialog();
                                    //     var id2 = field.id;
                                    //     bd.openDialog(bd, id2, DetailHelp.getView(field.id));
                                    // }
                                }
                            >
                                ⓘ
                            </span>
                            <sup id={`fieldsavestatus-${field.id}`}>
                                {field.savedstatus && field.savedstatus.statusCode > 0
                                    ? field.savedstatus.statusCode === 200
                                        ? '.fieldsaved'
                                        : '.fieldsaveerror'
                                    : ''}
                                <span>
                                    {field.savedstatus
                                        ? field.savedstatus.statusCode === 200
                                            ? '.fieldmodifiedsaved'
                                            : '.fieldmodifiederror'
                                        : ''}
                                    &nbsp;
                                    {field.savedstatus
                                        ? field.savedstatus.statusCode === 200
                                            ? 'saved'
                                            : '&#9888;'
                                        : ''}
                                </span>
                            </sup>
                        </span>
                    ) : (
                        <></>
                    )}
                </div>
            )
        case 'single-select-dropdown':
        case 'multi-select-dropdown':
            return GroupWidget({
                field: field,
                fieldSetInstance: fieldSetInstance,
                fieldIndex: fieldIndex,
                setIndex: setIndex,
                updateFieldValue: updateFieldValue,
            })
        case 'custom':
            let textVal = 'Component unimplemented or not configured, please contact the vendor.'
            if (field.custom == 'null') {
                textVal = 'Custom field not implemented yet.'
            } else if (field.custom === 'readonly') {
                textVal = field.value != null ? field.value : 'N/A'
            }
            return (
                <div id={domid}>
                    <span>{textVal}</span>
                </div>
            )
        case 'file':
            return (
                <div className="file-upload-container">
                    <input 
                        type="file" 
                        name={domid} 
                        id={domid} 
                        onChange= {
                            function (e: React.ChangeEvent<HTMLInputElement>) {
                                const file = e.target.files ? e.target.files[0] : null;
                                if (file) {
                                    updateFieldValue([file.name]);
                                    fieldDispatch({
                                        type: FormActionKind.updateFieldFile,
                                        payload: {
                                            file: file,
                                            fileId: field.id,
                                        },
                                    })
                                } else {
                                    updateFieldValue([]);
                                    fieldDispatch({
                                        type: FormActionKind.updateFieldFile,
                                        payload: {
                                            file: null,
                                            filedId: field.id,
                                        },
                                    })
                                }
                            }
                        }
                        disabled={formDisabled} 
                    />
                    <div>
                        {field.fieldValue && field.fieldValue.length > 0 ? (
                            <a href={field.FileUrl} download>{field.FromFile}</a>
                        ) : (
                            <span className="file-upload-placeholder">No file chosen</span>
                        )}
                    </div>
                </div>
            )
        default:
            return <span>&nbsp;</span>
    }
}
// TODO : memoize? avoid unnecessary re-renders

const Output = (props: {
    formDisabled: boolean
    field: { [s: string]: any }
    fieldSetInstance: { [s: string]: any }
    setIndex: number
    fieldIndex: number
    updateFieldIndex: (newIndex: string[]) => void
    updateFieldValue: (s: any) => void
    updateValue: (s: any) => void
}) => {
    const {
        formDisabled,
        field,
        fieldSetInstance,
        setIndex,
        fieldIndex,
        updateFieldIndex,
        updateFieldValue,
        updateValue,
    } = props
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const isAdmin = ['FoundationsSystemAdmin', 'SystemAdmin'].indexOf(currentUserData.type) > -1
    const [missingRequired, setMissingRequired] = useState(false)
    const { formState } = useFormEngineContext()

    useEffect(() => {
        if (field.required && !!formState.isSaved){
            setMissingRequired(((!field.fieldValue[0])) )
        }
    },[field.fieldValue, field.fieldIndex[0], formState.isSaved])
    // TODO: is this needed?
    // let status = fieldSetValidation.fieldStatus(
    //     addAuditComment,
    //     formState.schema.sections,
    //     formState.validatorMetaMap,
    //     formState.templateType,
    //     field,
    //     fieldSetInstance
    // )
    let validity = fieldSetValidation.fieldValidity(field, fieldSetInstance)
    return (
        <div className={field.id != 2072 ? 'row mx-2 mb-1' : 'row-plugin subGroup'}>
            <div
                className={
                    field.type == 'note'
                        ? ' fullWidth note fieldlabel'
                        : field.type == 'separator' || field.type == 'contextView'
                          ? ''
                          : field.type == 'select'
                            ? ' four-sixth'
                            : field.type == 'checkboxGroup'
                              ? ' one-sixth fieldlabel'
                              : field.type == 'radioSelect'
                                ? ' longLabel '
                                : ' col-md-4 fieldlabel'
                }
            >
                {field.type == 'separator' || field.type == 'note' || field.type == 'contextView'
                    ? ''
                    : (isAdmin ? ' [' + field.id + '] ' : '') +
                      field.name.trim() +
                      (field.required ? '*' : '')}
            </div>
            <div
                className={
                    (field.type == 'note'
                        ? 'note'
                        : field.type == 'separator' || field.type == 'contextView'
                          ? 'svg_barcode px-0 col-12'
                          : field.type == 'checkboxGroup'
                            ? ' four-sixth'
                            : ' col-md-7'
                    ) + (missingRequired ? ' failed-form-field' : '')
                }

            >
                {validity.issue || validity.warning ? (
                    <div className="stack" id={field.id}>
                        <FieldInfo
                            formDisabled={formDisabled}
                            field={field}
                            fieldSetInstance={fieldSetInstance}
                            setIndex={setIndex}
                            fieldIndex={fieldIndex}
                            updateFieldIndex={updateFieldIndex}
                            updateFieldValue={updateFieldValue}
                            updateValue={updateValue}
                        />
                        {validity.issue}
                        {validity.warning ? (
                            <>
                                <br /> Value is outside the normal range. {validity.help}
                            </>
                        ) : (
                            <></>
                        )}
                        {validity.hint ? (
                            <>
                                <br /> {validity.hint}
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                ) : (
                    <div id={field.id}>
                        <FieldInfo
                            formDisabled={formDisabled}
                            field={field}
                            fieldSetInstance={fieldSetInstance}
                            setIndex={setIndex}
                            fieldIndex={fieldIndex}
                            updateFieldIndex={updateFieldIndex}
                            updateFieldValue={updateFieldValue}
                            updateValue={updateValue}
                        />
                    </div>
                )}
            </div>
            <span className={(missingRequired ? "" : "hide ") + "field-validation-error"}>
                *Required field
            </span>
        </div>
    )
}

const Field = React.memo(
    (props: {
        formDisabled: boolean
        field: { [s: string]: any }
        fieldSetInstance: { [s: string]: any }
        setIndex: number
        fieldIndex: number
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void
        setShowPopupMessage: (show: boolean) => void
    }) => {
        const {
            formDisabled,
            field,
            fieldSetInstance,
            setIndex,
            fieldIndex,
            setPopUpInfo,
            setShowPopupMessage,
        } = props
        const { fieldDispatch } = useFieldContext()
        const { formState, formDispatch } = useFormEngineContext()
        const updateFieldValue = (newValue: any) => {
            fieldDispatch({
                type: FormActionKind.updateFieldInstance,
                payload: {
                    newValue: newValue,
                    fieldId: field.id,
                    setIndex: setIndex,
                    fieldIndex: fieldIndex,
                    attribute: 'fieldValue',
                },
            })
        }
        const updateValue = (newValue: any) => {
            fieldDispatch({
                type: FormActionKind.updateFieldInstance,
                payload: {
                    newValue: newValue,
                    fieldId: field.id,
                    setIndex: setIndex,
                    fieldIndex: fieldIndex,
                    attribute: 'value',
                },
            })
        }
        const updateFieldIndex = (newIndex: string[]) => {
            fieldDispatch({
                type: FormActionKind.updateFieldInstance,
                payload: {
                    newValue: newIndex,
                    fieldId: field.id,
                    setIndex: setIndex,
                    fieldIndex: fieldIndex,
                    attribute: 'fieldIndex',
                },
            })
        }
        let show = true
        // TODO : test if onceOnly is actually used anywhwere
        // if (index !== 0) {
        //     show = _.find(onceOnly, function (fx) { return (field.id === fx); }) ? false : true;
        // }
        show =
            show &&
            formHelp.isDependencyOk(
                true,
                field,
                setIndex,
                // TODO => formState.schema.sections has to update value of parent to 1 when selected, 0 when unselected
                formState.schema.sections,
                formState.validatorMetaMap,
                formState.templateType,
                fieldSetInstance,
                null,
                formState.addAuditComment,
                setPopUpInfo,
                setShowPopupMessage
            )
        // do not show the NULL custom field, which is a placefoler for dependency chencking for subforms
        show =
            show &&
            (field.type !== 'custom' || (field.type === 'custom' && field.custom !== 'null'))
        if (field.fieldValue?.length > 0 && field.fieldValue[0] !== 'Unknown' && !show) {
            if (field.type == 'radio') updateFieldValue(['Unknown'])
            else updateFieldValue([])
        }

        if (show) {
            return field.type.toLowerCase() == 'hidden' ? (
                <div></div>
            ) : field.type !== 'sectionChild' ? (
                <div>
                    {fieldIndex > 0 && field.type !== 'separator' ? (
                        <>
                            <hr className="mr-2 mt-0" />
                            <Output
                                formDisabled={formDisabled}
                                field={field}
                                fieldSetInstance={fieldSetInstance}
                                setIndex={setIndex}
                                fieldIndex={fieldIndex}
                                updateFieldIndex={updateFieldIndex}
                                updateFieldValue={updateFieldValue}
                                updateValue={updateValue}
                            />
                        </>
                    ) : (
                        <>
                            <Output
                                formDisabled={formDisabled}
                                field={field}
                                fieldSetInstance={fieldSetInstance}
                                setIndex={setIndex}
                                fieldIndex={fieldIndex}
                                updateFieldIndex={updateFieldIndex}
                                updateFieldValue={updateFieldValue}
                                updateValue={updateValue}
                            />
                        </>
                    )}
                </div>
            ) : (
                <div></div>
            )
        } else {
            return <div></div>
        }
    }
)

const FieldSet = React.memo(
    (props: {
        formDisabled: boolean
        instance: { [s: string]: any }
        setIndex: number
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void
        setShowPopupMessage: (show: boolean) => void
    }) => {
        const { formDisabled, instance, setIndex, setPopUpInfo, setShowPopupMessage } = props
        return (
            <span>
                {instance.fields.map(function (field: { [s: string]: any }, fieldIndex: number) {
                    return (
                        <Field
                            formDisabled={formDisabled}
                            key={field.id + '_' + fieldIndex}
                            field={field}
                            fieldSetInstance={instance}
                            setIndex={setIndex}
                            fieldIndex={fieldIndex}
                            setPopUpInfo={setPopUpInfo}
                            setShowPopupMessage={setShowPopupMessage}
                        />
                    )
                })}
            </span>
        )
    }
)
